import {
	lazy,
} from 'react'

export const RoomPageAsync = lazy(async() => {
	return import('./room.page')
})
